/* POZOR: z tohoto souboru se už používají jen MUTACE_POZNAMKY a KLASIFIKACE_MEDII
   (čistě popisné vysvětlivky). Zbytek nahradilo API — viz statisticsSettingsApi.js.
   Konstanty tady zůstávají jako reference k podkladům klienta. */
/**
 * Statistiky → Nastavení sazeb a číselníků — STATICKÁ mock data.
 *
 * Obrazovka je zatím jen návrh podoby k odsouhlasení klientem, nic se nenačítá
 * z API a nic se neukládá. Až bude podoba schválená, vymění se tenhle soubor
 * za volání backendu.
 *
 * Číselníky jsou opsané z podkladů od klienta:
 *   • procenta provizí 2026 (platné od 01.05.2026)
 *   • bonusy tituly 2026
 *   • přehled titulů – možné slevy (platné k 08.07.2026)
 *   • Definice Provizí.docx
 *
 * Seznam titulů je tu úmyslně vlastní a úplnější než TITULY v
 * statisticsMockData.js — sestava provizí potřebuje jen objem a maximální
 * slevu, kdežto nastavení pracuje s plány, kompetencemi a klasifikací.
 * Oba seznamy se při napojení nahradí jedním číselníkem z API.
 */

import { BONUS_PASMA, OBCHODNICI } from './statisticsMockData';

export { BONUS_PASMA, OBCHODNICI };

/* --------------------------------------------------------------- platnost */
export const PLATNOST_SAZEB = '01.05.2026';
export const PLATNOST_SLEV = '08.07.2026';

/* ------------------------------------------- procenta provizí (složka J) - */
/** Naše média — pásmo se určí podle plnění plánu vydání. */
export const PASMA_VYDANI_SAZBY = [
  { kod: 8, pct: 0.08, nazev: 'ultra neplnění plánu' },
  { kod: 11, pct: 0.11, nazev: 'neplnění plánu' },
  { kod: 14, pct: 0.14, nazev: 'plán – 1. hranice' },
  { kod: 17, pct: 0.17, nazev: 'plán – 2. hranice' },
  { kod: 20, pct: 0.20, nazev: 'plán – nejvyšší' },
];

export const ZAKLAD_PARTNER = 0.12;   // přenastavitelné na úrovni titulu
export const ZAKLAD_SPECIAL = 0.10;   // přenastavitelné na úrovni titulu
export const PENALIZACE_ZA_SLEVU = 0.005; // −0,5 p.b. provize za 1 p.b. slevy nad maximum
export const PROVIZE_MIN = 0;         // provize nikdy nesmí být záporná

/* ------------------------------------------------- korekce za splatnost -- */
export const KOREKCE_SPLATNOST = [
  { kod: 'ok', do: 45, koef: 1.0, nazev: '0–45 dní', popis: 'bez krácení', ikona: 'bi-check-circle-fill' },
  { kod: 'half', do: 90, koef: 0.5, nazev: '46–90 dní', popis: 'krácení 50 %', ikona: 'bi-exclamation-triangle-fill' },
  { kod: 'zero', do: null, koef: 0.0, nazev: '91+ dní', popis: 'krácení 100 %', ikona: 'bi-x-circle-fill' },
];

/** Další pravidla úhrad z Definice provizí — jen text, nic se nepočítá.
 *  Na obrazovce se zatím nezobrazují (klient si je nechal skrýt). */
export const PRAVIDLA_UHRAD = [
  'Provize se vyplácí pouze z uhrazených plateb (banka nebo cash); ze zápočtů a dalších účetních operací nikoli.',
  'Každou úhradu je nutné očistit o DPH (sazby 21 % / 12 % / 0 %).',
  'Částečná úhrada nebo vícepoložková faktura → uhrazenou částku rozpustit poměrově na položky (i DPH poměrově).',
  'Faktura v cizí měně → přepočet na Kč kurzem k datu úhrady.',
  'Zálohová faktura → provizi párovat až na dokladovou fakturu, aby nevznikly dvojí provize.',
  'Položka s více obchodníky → hodnota se rozdělí mezi obchodníky (výchozí klíč poměrový).',
];

/* ---------------------------------------------------- podmínky nároku --- */
/** Brána nároku na bonus — stačí splnit alespoň jednu podmínku. */
export const PODMINKY_BONUSU = [
  {
    id: 'p1',
    nazev: 'Splnění měsíčních obratů významných médií',
    popis: 'na 14 %: Noviny kraje; na 11 %: Boleslavan, Čtrnáctka, Jižní listy, Klíč, Kraj Vysočina, '
      + 'Krajánek, Mostecké listy, Radnice HK, Ústecké noviny, Váš Zlín, od 1. 6. Jihomoravské noviny',
  },
  {
    id: 'p2',
    nazev: 'Obrat alespoň ve třech významných titulech',
    popis: 'cca 10 % z měsíčního plánu v každém ze tří titulů, nebo 7 % v každém z uvedených '
      + '(počítáno z plánů na 14 %)',
  },
  {
    id: 'p3',
    nazev: 'Obrat ≥ 20 % celkového měsíčního plánu',
    popis: 'v našich médiích, počítáno z plánů na 14 %',
  },
];

/* --------------------------------------------------------------- manažeři */
export const MANAZERI = [
  { id: 'MG-CHAR', jmeno: 'Charvátová Gabriela', role: 'obchodní ředitelka' },
  { id: 'MG-VRV', jmeno: 'Vrbický Vít', role: 'obchodní manažer' },
  { id: 'MG-HAD', jmeno: 'Hadravová Štěpánka', role: 'obchodní manažerka' },
];

/** Kdo komu podléhá — Charvátová jako OŘ nemá nadřízeného. */
export const MANAZER_OBCHODNIKA = {
  'OZ-VRV': 'MG-CHAR',
  'OZ-HAD': 'MG-CHAR',
  'OZ-CHA': null,
  'OZ-MAT': 'MG-VRV',
  'OZ-TOM': 'MG-VRV',
  'OZ-LIB': 'MG-HAD',
  'OZ-BRE': 'MG-HAD',
  'OZ-HRD': 'MG-VRV',
  'OZ-JAK': 'MG-HAD',
  'OZ-VRL': 'MG-CHAR',
  'OZ-DOB': 'MG-HAD',
};

/* ==========================================================================
   ČÍSELNÍK TITULŮ
   typ:   'nase' | 'partner' | 'special'
   plany: hranice obratu vydání pro pásma 11 / 14 / 17 / 20 (Kč, NET)
   slevy: { oz, manazerTitulu, manazerRegionu, maxBezSouhlasu } v procentech
   ========================================================================== */
export const TITULY_NASTAVENI = [
  /* ------------------------------------------------------- naše média --- */
  {
    id: 'T-NK', nazev: 'Noviny kraje – komplet', typ: 'nase', kraj: 'celá ČR', lokalita: 'celá ČR',
    periodicita: 'měsíčník', stran: 12, plany: { p11: 480000, p14: 595000, p17: 735000, p20: 940000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 14,
    poznamka: 'Plán vydání = součet plánů mutací v daném vydání + kompletová inzerce.',
  },
  {
    id: 'T-KLIC', nazev: 'Klíč', typ: 'nase', kraj: 'Praha', lokalita: 'Praha 11',
    periodicita: 'měsíčník', stran: 32, plany: { p11: 150000, p14: 190000, p17: 230000, p20: 285000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: '+ 4 inzertní strany = + 80, 90, 110, 115 tis. Kč.',
  },
  {
    id: 'T-CTRN', nazev: 'Čtrnáctka', typ: 'nase', kraj: 'Praha', lokalita: 'Praha 14',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 90000, p14: 125000, p17: 160000, p20: 185000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Za přidaných 16 stran (4,8 inzertní) plán = 120, 160, 200, 240 tis. Kč.',
  },
  {
    id: 'T-BOL', nazev: 'Boleslavan', typ: 'nase', kraj: 'Středočeský', lokalita: 'Mladá Boleslav',
    periodicita: 'měsíčník', stran: 44, plany: { p11: 145000, p14: 190000, p17: 235000, p20: 270000 },
    slevy: { oz: 40, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 60 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Při 40 stranách plán = 140, 180, 220, 255 tis.; při 48 stranách 150, 190, 250, 285 tis. Kč.',
  },
  {
    id: 'T-KLAUD', nazev: 'Klaudiánova nemocnice', typ: 'nase', kraj: 'Středočeský', lokalita: 'Mladá Boleslav',
    periodicita: 'dvouměsíčník', stran: 16, plany: { p11: 15000, p14: 25000, p17: 35000, p20: 45000 },
    slevy: { oz: 40, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 60 },
  },
  {
    id: 'T-KLAD', nazev: 'Zpravodaj Nemocnice Kladno', typ: 'nase', kraj: 'Středočeský', lokalita: 'Kladno',
    periodicita: 'kvartálník', stran: 16, plany: { p11: 22000, p14: 27000, p17: 34000, p20: 40000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
  },
  {
    id: 'T-RUDNA', nazev: 'Život v Rudné', typ: 'nase', kraj: 'Středočeský', lokalita: 'Rudná u Prahy',
    periodicita: 'měsíčník', stran: 20, plany: { p11: 16000, p14: 22000, p17: 28000, p20: 33000 },
    slevy: { oz: null, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 20 },
    slevaPozn: 'sleva OZ dle ceníku',
  },
  {
    id: 'T-LOUNY', nazev: 'Lounský měsíčník', typ: 'nase', kraj: 'Ústecký', lokalita: 'Louny',
    periodicita: 'měsíčník', stran: 20, plany: { p11: 20000, p14: 27000, p17: 34000, p20: 40000 },
    slevy: { oz: 20, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 40 },
    poznamka: '+ 4 inzertní strany = + 7, 10, 14, 20 tis. Kč.',
  },
  {
    id: 'T-MOST', nazev: 'Mostecké listy', typ: 'nase', kraj: 'Ústecký', lokalita: 'Most',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 50000, p14: 60000, p17: 70000, p20: 85000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Při 16 stranách plány 25, 30, 40, 50 tis. Kč.',
  },
  {
    id: 'T-USTI', nazev: 'Ústecké noviny', typ: 'nase', kraj: 'Ústecký', lokalita: 'Ústí n. Labem',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 90000, p14: 110000, p17: 130000, p20: 160000 },
    slevy: { oz: 40, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 60 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: '20 stran = 75, 90, 105, 130 tis.; 16 stran = 55, 65, 75, 100 tis. '
      + 'Redakční strana nad 12 stran se počítá do plánu (+ 7 400 Kč).',
  },
  {
    id: 'T-RADN', nazev: 'Radnice', typ: 'nase', kraj: 'Královéhradecký', lokalita: 'Hradec Králové',
    periodicita: 'týdeník', stran: 16, plany: { p11: 65000, p14: 80000, p17: 90000, p20: 120000 },
    mesicniAgregace: true,
    slevy: { oz: 50, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 70 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Sčítá se plnění všech vydání v měsíci proti součtu plánů měsíce (počítá se průměr za celý měsíc).',
  },
  {
    id: 'T-VYS', nazev: 'Kraj Vysočina – komplet', typ: 'nase', kraj: 'Vysočina', lokalita: 'Vysočina',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 150000, p14: 190000, p17: 230000, p20: 285000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Od vydání 2026/05 platí snížené plány 110 / 145 / 185 / 230 tis. Kč.',
  },
  {
    id: 'T-STRAK', nazev: 'Zpravodaj města Strakonice', typ: 'nase', kraj: 'Jihočeský', lokalita: 'Strakonice',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 40000, p14: 50000, p17: 60000, p20: 75000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    poznamka: 'Od 2026/04 na 24 stran. + 4 strany (2 inzertní) = + 12, 15, 20, 25 tis. Kč.',
  },
  {
    id: 'T-PISEK', nazev: 'Zpravodaj města Písku', typ: 'nase', kraj: 'Jihočeský', lokalita: 'Písek',
    periodicita: 'měsíčník', stran: 20, plany: { p11: 35000, p14: 45000, p17: 60000, p20: 70000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
  },
  {
    id: 'T-TABOR', nazev: 'Noviny táborské radnice', typ: 'nase', kraj: 'Jihočeský', lokalita: 'Tábor',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 25000, p14: 30000, p17: 35000, p20: 40000 },
    slevy: { oz: 10, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 30 },
  },
  {
    id: 'T-JIZNI', nazev: 'Jižní listy', typ: 'nase', kraj: 'Moravskoslezský', lokalita: 'Ostrava-jih',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 65000, p14: 80000, p17: 95000, p20: 115000 },
    slevy: { oz: 20, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 40 },
    vyznamne: true, vyznamneNa: 11,
  },
  {
    id: 'T-ZLIN', nazev: 'Magazín Váš Zlín', typ: 'nase', kraj: 'Zlínský', lokalita: 'Zlín',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 110000, p14: 145000, p17: 175000, p20: 220000 },
    slevy: { oz: 40, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 60 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Od 2024/03 včetně obálky. + 4 strany (2 inzertní) plán = + 15, 20, 25, 30 tis. Kč.',
  },
  {
    id: 'T-UH', nazev: 'Zpravodaj města Uherské Hradiště', typ: 'nase', kraj: 'Zlínský', lokalita: 'Uherské Hradiště',
    periodicita: 'měsíčník', stran: 20, plany: { p11: 45000, p14: 60000, p17: 75000, p20: 90000 },
    slevy: { oz: 20, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 40 },
  },
  {
    id: 'T-VESEL', nazev: 'Veselské listy', typ: 'nase', kraj: 'Jihomoravský', lokalita: 'Veselí nad Moravou',
    periodicita: 'měsíčník', stran: 24, plany: { p11: 45000, p14: 55000, p17: 65000, p20: 75000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    poznamka: '+ 4 strany (2 inzertní) plán + 4, 8, 12, 16 tis. Kč.',
  },
  {
    id: 'T-JMN', nazev: 'Jihomoravské noviny – komplet', typ: 'nase', kraj: 'Jihomoravský', lokalita: 'Jihomoravský kraj',
    periodicita: 'pololetník', stran: 16, plany: { p11: 300000, p14: 340000, p17: 390000, p20: 450000 },
    slevy: { oz: 10, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 30 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: 'Do významných médií pro nárok na bonus zařazeny od 1. 6.',
  },
  {
    id: 'T-OLK', nazev: 'Olomoucký kraj – komplet', typ: 'nase', kraj: 'Olomoucký', lokalita: 'Olomoucký kraj',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 150000, p14: 180000, p17: 220000, p20: 260000 },
    slevy: { oz: 10, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 30 },
  },
  {
    id: 'T-JESEN', nazev: 'Naše město Jeseník', typ: 'nase', kraj: 'Olomoucký', lokalita: 'Jeseník',
    periodicita: 'měsíčník', stran: 12, plany: { p11: 10000, p14: 12000, p17: 14000, p20: 16000 },
    slevy: { oz: 10, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 30 },
  },
  {
    id: 'T-KVARY', nazev: 'Karlovarské radniční listy', typ: 'nase', kraj: 'Karlovarský', lokalita: 'Karlovy Vary',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 10000, p14: 25000, p17: 25000, p20: 25000 },
    bezBonusu: true,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
    provizePozn: '8–16 %',
    poznamka: 'Od 1. 7. 2023 bez bonusové provize. Pásma 17 % a 20 % nejsou nastavena.',
  },
  {
    id: 'T-KRAJ', nazev: 'Krajánek', typ: 'nase', kraj: 'Středočeský', lokalita: 'Kolínsko, Kutnohorsko',
    periodicita: 'měsíčník', stran: 16, plany: { p11: 0, p14: 0, p17: 0, p20: 0 }, planNeurcen: true,
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
    vyznamne: true, vyznamneNa: 11,
    poznamka: '⚠ Plány pro 2026 zatím nenastaveny – bez plánu se počítá pásmo 8 %.',
  },
  {
    id: 'T-WEB1', nazev: 'www.novinykraje.cz', typ: 'nase', kraj: 'celá ČR', lokalita: 'online',
    periodicita: 'průběžně', stran: null, plany: { p11: 0, p14: 50000, p17: 65000, p20: 80000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
  },
  {
    id: 'T-WEB2', nazev: 'www.fajnvylety.cz', typ: 'nase', kraj: 'celá ČR', lokalita: 'online',
    periodicita: 'průběžně', stran: null, plany: { p11: 0, p14: 10000, p17: 20000, p20: 30000 },
    slevy: { oz: 30, manazerTitulu: 10, manazerRegionu: 10, maxBezSouhlasu: 50 },
  },

  /* ------------------------------- partnerská média (základ 12 %, resp. 8 %) */
  {
    id: 'P-OSM', nazev: 'Osmička', typ: 'partner', kraj: 'Praha', lokalita: 'Praha 8',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-SLAN', nazev: 'Slánské listy – PLUS', typ: 'partner', kraj: 'Středočeský',
    lokalita: 'Slánsko, Rakovnicko, Kladensko', periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-ZAPR', nazev: 'Zápraží', typ: 'partner', kraj: 'Středočeský', lokalita: 'Říčansko, Čestlicko',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
  },
  {
    id: 'P-PLZ', nazev: 'Plzeňský Rozhled', typ: 'partner', kraj: 'Plzeňský',
    lokalita: 'Plzeň, Rokycany, Tachov, Stříbro', periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-KLAT', nazev: 'Klatovský Rozhled', typ: 'partner', kraj: 'Plzeňský', lokalita: 'Klatovsko',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-RJC', nazev: 'Rozhled jižní Čechy', typ: 'partner', kraj: 'Jihočeský',
    lokalita: 'Č. Budějovice, Táborsko, Prachaticko', periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-TEP', nazev: 'Žít Teplice', typ: 'partner', kraj: 'Ústecký', lokalita: 'Teplice',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-DECIN', nazev: 'Zpravodaj města Děčín', typ: 'partner', kraj: 'Ústecký', lokalita: 'Děčín',
    periodicita: 'čtrnáctideník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-LIPA', nazev: 'Lípa', typ: 'partner', kraj: 'Liberecký', lokalita: 'Česká Lípa, Mimoň, Nový Bor',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
  },
  {
    id: 'P-PERN', nazev: 'Týdeník Pernštejn', typ: 'partner', kraj: 'Pardubický', lokalita: 'Pardubice, Holice',
    periodicita: 'týdeník', zakladProvize: 0.12,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
  },
  {
    id: 'P-TRUT', nazev: 'Trutnovinky', typ: 'partner', kraj: 'Královéhradecký', lokalita: 'Trutnov',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
  },
  {
    id: 'P-VRCH', nazev: 'Vrchlabský patriot', typ: 'partner', kraj: 'Královéhradecký', lokalita: 'Vrchlabí',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-ECHO', nazev: 'Echo', typ: 'partner', kraj: 'Královéhradecký', lokalita: 'Náchodsko',
    periodicita: 'týdeník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-FMP', nazev: 'Frýdecko-místecký patriot', typ: 'partner', kraj: 'Moravskoslezský',
    lokalita: 'Frýdek-Místek', periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 10, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 20 },
  },
  {
    id: 'P-HLAS', nazev: 'Hláska', typ: 'partner', kraj: 'Moravskoslezský', lokalita: 'Opava',
    periodicita: 'měsíčník', zakladProvize: 0.12,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 10, maxBezSouhlasu: 10 },
  },
  {
    id: 'P-CBROD', nazev: 'Českobrodský zpravodaj', typ: 'partner', kraj: 'Středočeský', lokalita: 'Český Brod',
    periodicita: 'měsíčník', zakladProvize: 0.08,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 0, maxBezSouhlasu: 0 },
  },
  {
    id: 'P-ZURN', nazev: 'Žurnál', typ: 'partner', kraj: 'Jihočeský', lokalita: 'Jindřichův Hradec',
    periodicita: 'měsíčník', zakladProvize: 0.08,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 0, maxBezSouhlasu: 0 },
  },
  {
    id: 'P-LBC', nazev: 'Liberecký zpravodaj', typ: 'partner', kraj: 'Liberecký', lokalita: 'Liberec',
    periodicita: 'měsíčník', zakladProvize: 0.08,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 0, maxBezSouhlasu: 0 },
  },
  {
    id: 'P-OBEL', nazev: 'Obelisk', typ: 'partner', kraj: 'Zlínský', lokalita: 'Valašské Meziříčí',
    periodicita: 'měsíčník', zakladProvize: 0.08,
    slevy: { oz: 0, manazerTitulu: 0, manazerRegionu: 0, maxBezSouhlasu: 0 },
  },

  /* ------------------------------ speciální operace (základ 10 %, bez bonusu) */
  {
    id: 'S-TISK', nazev: 'Redakční / grafické zpracování, tisk a distribuce', typ: 'special',
    kraj: 'celá ČR', lokalita: '—', periodicita: 'zakázkově', zakladProvize: 0.10, slevy: {},
  },
  {
    id: 'S-INZ', nazev: 'Zajištění inzerce (externí tituly)', typ: 'special',
    kraj: 'celá ČR', lokalita: '—', periodicita: 'zakázkově', zakladProvize: 0.10, slevy: {},
  },
];

/* ==========================================================================
   MUTACE NOVIN KRAJE A KRAJE VYSOČINA
   Plán mutace se mění po dvou osách: rozsah stran a velikost podle nákladu.
   ========================================================================== */
export const MUTACE_PLANY = {
  velka: { p11: 0, p14: 85000, p17: 105000, p20: 135000, naklad: 'max 33 000 ks' },
  stredni: { p11: 0, p14: 60000, p17: 75000, p20: 95000, naklad: 'max 23 000 ks' },
  mala: { p11: 0, p14: 50000, p17: 60000, p20: 75000, naklad: 'max 14 000 ks' },
};

export const VELIKOSTI_MUTACI = [
  { id: 'mala', label: 'malá' },
  { id: 'stredni', label: 'střední' },
  { id: 'velka', label: 'velká' },
];

export const MUTACE_NASTAVENI = [
  { id: 'M-BEN', titulId: 'T-NK', nazev: 'Benešovsko', velikost: 'stredni', stran: 12 },
  { id: 'M-CHOM', titulId: 'T-NK', nazev: 'Chomutovsko', velikost: 'velka', stran: 12 },
  { id: 'M-HOD', titulId: 'T-NK', nazev: 'Hodonínsko', velikost: 'stredni', stran: 12 },
  { id: 'M-MB', titulId: 'T-NK', nazev: 'Mladoboleslavsko', velikost: 'velka', stran: 16 },
  { id: 'M-P9', titulId: 'T-NK', nazev: 'Místní noviny Praha 9', velikost: 'mala', stran: 12 },
  { id: 'M-PJV', titulId: 'T-NK', nazev: 'Místní noviny Praha-jihovýchod', velikost: 'stredni', stran: 12 },
  { id: 'M-PSEV', titulId: 'T-NK', nazev: 'Místní noviny Praha-sever', velikost: 'mala', stran: 12 },
  { id: 'M-NYM', titulId: 'T-NK', nazev: 'Nymbursko', velikost: 'mala', stran: 12 },
  { id: 'M-PVME', titulId: 'T-NK', nazev: 'Praha-východ (S) / Mělnicko', velikost: 'velka', stran: 12 },
  { id: 'M-PZAP', titulId: 'T-NK', nazev: 'Praha-západ (S)', velikost: 'stredni', stran: 12 },
  { id: 'M-JIH', titulId: 'T-VYS', nazev: 'Jihlava', velikost: 'stredni', stran: 12 },
  { id: 'M-PEL', titulId: 'T-VYS', nazev: 'Pelhřimov', velikost: 'mala', stran: 12 },
  { id: 'M-TRE', titulId: 'T-VYS', nazev: 'Třebíč', velikost: 'stredni', stran: 12 },
  { id: 'M-ZDAR', titulId: 'T-VYS', nazev: 'Žďár nad Sázavou', velikost: 'stredni', stran: 12 },
];

/** Poznámky k plánům mutací podle rozsahu stran (z podkladu „bonusy tituly 2026"). */
export const MUTACE_POZNAMKY = [
  'Velká: −4 strany = 0/75/95/125, +4 strany = 0/95/125/155, +8 stran = 0/125/155/200 tis. Kč.',
  'Střední: −4 strany = 0/50/60/75, +4 strany = 75/95/125, +8 stran = 0/85/105/135 tis. Kč.',
  'Malá: −4 strany = 0/40/50/60, +4 strany = 60/75/95, +8 stran = 0/65/75/95 tis. Kč.',
];

/* ---------------------------------------------------- klasifikace médií -- */
export const KLASIFIKACE_MEDII = [
  {
    id: 'nase', nazev: 'Naše média', cls: 'b-nase', ikona: 'bi-newspaper',
    popis: 'provize z vydání 8–20 % podle plnění plánu + bonusová provize',
  },
  {
    id: 'partner', nazev: 'Partnerská média', cls: 'b-partner', ikona: 'bi-share',
    popis: 'základ 12 % (nastavitelný), bez bonusu, penalizace za slevu nad maximum',
  },
  {
    id: 'special', nazev: 'Speciální operace', cls: 'b-special', ikona: 'bi-box-seam',
    popis: 'základ 10 % (nastavitelný), bez bonusu – tisk, distribuce, zajištění inzerce',
  },
];

export const TITUL_NASTAVENI_BY_ID = Object.fromEntries(TITULY_NASTAVENI.map(t => [t.id, t]));
export const MANAZER_BY_ID = Object.fromEntries(MANAZERI.map(m => [m.id, m]));
